<div>
  <img src="assets/logo.svg" alt="Mercedes logo" class="img-fluid d-block" style="margin: 0 auto">
  <h6 class="display-6 text-center">Loading data...</h6>
</div>